import { useState, useContext, useEffect } from "react";
import "./actionsPlannedDrawer.scss";
import { Drawer } from "antd";

// context
import { QuestionnaireContext } from "../../contexts/questionnaireContext";

// icon
import { rightArrowIcon } from "../../constants/icons";

// interface
import {
  ActionData,
  ActionSubSecData,
  ActionList,
} from "../../interfaces/actionsPlanned";
interface ActionSectionData {
  section_id: string;
  section: string;
  color: string;
  actions: ActionData[];
  sub_sections: {
    sub_section_id: string;
    title: string;
    actions: ActionData[];
  }[];
}

const ActionsPlannedDrawer = ({
  actionDrawer,
  toggleDrawer,
}: {
  actionDrawer: boolean;
  toggleDrawer: any;
}) => {
  const { evalScope, actionsPlanned } = useContext(QuestionnaireContext);
  const [actionList, setActionList] = useState<ActionList>({
    evaluation_id: "",
    sections: [],
  });

  useEffect(() => {
    setActionList(actionsPlanned);
    // eslint-disable-next-line
  }, [actionsPlanned]);

  return (
    <Drawer
      placement="bottom"
      closable={true}
      key="bottom"
      height="60dvh"
      title="Actions identified to satisfy requirements"
      open={actionDrawer}
      onClose={toggleDrawer}
      mask={false}
    >
      <div className="actionsPlannedDrawerContainer">
        <span className="drawerTitle">
          {evalScope.name} / Actions identified
        </span>
        {actionList.sections.map((ap: ActionSectionData, apIndex: number) => (
          <div className="sectionContainer" key={ap.section_id}>
            <div className="section">
              <div className="sectionName">
                <div
                  className="colorPlate"
                  style={{
                    backgroundColor: `${ap.color}`,
                  }}
                ></div>
                <span className="name">{ap.section}</span>
              </div>
              {ap.actions.length > 0 &&
                ap.actions.map((action: ActionData) => (
                  <div className="actionDetail" key={action.question_id}>
                    <div className="actionQuestion">
                      <div className="qplate">Q{action.question_index}</div>
                      <span className="question">{action.question}</span>
                    </div>
                    <div className="actionData">
                      <span className="action">
                        {rightArrowIcon}
                        {action.action}
                      </span>
                    </div>
                  </div>
                ))}
              {ap.sub_sections.length > 0 &&
                ap.sub_sections.map((subsec: ActionSubSecData) => (
                  <div className="subsecAction" key={subsec.sub_section_id}>
                    <div className="title">
                      <hr className="horizontal" />
                      <span>{subsec.title}</span>
                      <hr className="horizontal" />
                    </div>
                    {subsec.actions.map((action: ActionData) => (
                      <div className="actionDetail" key={action.question_id}>
                      <div className="actionQuestion">
                        <div className="qplate">Q{action.question_index}</div>
                        <span className="question">{action.question}</span>
                      </div>
                      <div className="actionData">
                        <span className="action">
                          {rightArrowIcon}
                          {action.action}
                        </span>
                      </div>
                    </div>
                    ))}
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </Drawer>
  );
};

export default ActionsPlannedDrawer;
